module.exports = __webpack_public_path__ + "img/trees.b43ec238.svg";